module.exports = __webpack_public_path__ + "static/media/mev.5c4a4815.jpg";